/* Range index category filter.
 *
 * A range belongs to as many headline categories as it belongs to — Breaker is
 * a plug, a dildo and a depth toy — so this hides and shows cards rather than
 * navigating: an overlapping grouping has nothing to navigate to.
 *
 * The state lives in the URL (?category=plugs) so a nav link can point at a
 * pre-filtered view and a filtered page can be shared or reloaded.
 */
(() => {
  const PARAM = 'category';
  const ACTIVE = 'is-active';

  /**
   * Applies a category to one filter's pills and cards.
   * @param {HTMLElement} root - The section element.
   * @param {string} category - Handleized category, or '' for everything.
   */
  const apply = (root, category) => {
    const pills = root.querySelectorAll('[data-category]');
    const cards = root.querySelectorAll('[data-categories]');

    const title = root.querySelector('[data-range-label]');

    pills.forEach((pill) => {
      const on = pill.dataset.category === category;
      pill.classList.toggle(ACTIVE, on);
      pill.setAttribute('aria-pressed', on ? 'true' : 'false');

      // The active pill carries the wording for the title beside it, so the
      // two can never disagree about what the grid is showing.
      if (on && title && pill.dataset.label) title.textContent = pill.dataset.label;
    });

    cards.forEach((card) => {
      // Pipes on both ends of every value, so "depth" cannot match
      // "depth-play". The markup builds the attribute the same way.
      const owned = card.dataset.categories || '';
      const show = category === '' || owned.includes(`|${category}|`);
      card.hidden = !show;
    });
  };

  /**
   * Reads the category from the URL, falling back to everything.
   * @param {HTMLElement} root - The section element.
   * @returns {string} A category the page actually offers, or ''.
   */
  const fromUrl = (root) => {
    const wanted = new URLSearchParams(window.location.search).get(PARAM);
    if (!wanted) return '';
    // A stale or hand-typed value would otherwise empty the grid silently.
    return root.querySelector(`[data-category="${CSS.escape(wanted)}"]`) ? wanted : '';
  };

  const init = (filter) => {
    const root = filter.closest('.cc-range-index') || document;
    apply(root, fromUrl(root));

    filter.addEventListener('click', (event) => {
      const pill = event.target.closest('[data-category]');
      if (!pill) return;

      const category = pill.dataset.category;
      apply(root, category);

      const url = new URL(window.location.href);
      if (category) {
        url.searchParams.set(PARAM, category);
      } else {
        url.searchParams.delete(PARAM);
      }
      // Replace rather than push: filtering is not a place you go back to.
      window.history.replaceState({}, '', url);
    });
  };

  const start = () => document.querySelectorAll('[data-range-filter]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // The theme editor rebuilds a section's markup on every setting change.
  document.addEventListener('shopify:section:load', start);
})();
